import React, { useEffect } from 'lib/react';
import {
  EVGrid, EVTypography,
} from 'lib/components';
import clsx from 'lib/clsx';
import { useSelector, useDispatch } from 'lib/redux';
import { useTranslation } from 'lib/translation';
import LabelledCheckbox from 'commonComponents/labelled-checkbox';
import { updateInputFieldValue } from 'features/orderPreferences/OrderPreferences.actions';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import SelectField from 'commonComponents/select-field';
import { MEASUREMENT_REQUEST_TYPES, PRODUCT_FAMILY_ID_EVCORE } from 'constants/AppConstants';
import ProductSelectionStyles from '../ProductSelectionStyles';

function ProductSelectionMeasurement() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const orderPreferences = useSelector(({ userData }) => userData.orderPreferences);
  const inputFieldValues = useSelector(({ orderPreference }) => orderPreference.inputFieldValues);
  const productFamilyId = useSelector(({ userData }) => userData?.initParameters?.productFamilyId); // #genai

  const { isAdmin } = orderPreferences;
  const classes = ProductSelectionStyles();
  const measurementRequestType = getPropertyValues(orderPreferences, inputFieldValues, 'measurementRequestType');
  const orderMeasurementRequestHelpText = `order_measurementrequest_helptext_${measurementRequestType?.value || 1}`;

  // #genai Set default value to "All Structures on Parcel" (ID: 3) for EVCore product family
  useEffect(() => {
    if (productFamilyId === PRODUCT_FAMILY_ID_EVCORE && measurementRequestType?.value !== 3) {
      dispatch(updateInputFieldValue('measurementRequestType', 'value', 3));
    }
  }, [productFamilyId, measurementRequestType?.value, dispatch]);

  const handleChange = (e) => {
    const { target: { name, value } } = e;
    dispatch(updateInputFieldValue(name, 'value', value));
  };

  const handleMeasurementSubAccountsCheckBoxChange = (e) => {
    const { target: { name, checked } } = e;
    dispatch(updateInputFieldValue(name, 'allowSubAccounts', checked));
  };
  return (
    <EVGrid className={classes.measurementInstructionContainer}>
      <EVGrid className={classes.measurementInstructionHeaderContainer}>
        <EVTypography className={classes.structureTypeTitle}>{t('order_measurementinstructions')}</EVTypography>
        <EVTypography className={classes.productSelectionHeaderDesc}>{t(orderMeasurementRequestHelpText)}</EVTypography>
      </EVGrid>
      <EVGrid className={classes.measurementInstructionDDL}>
        <SelectField
          name="measurementRequestType"
          variant="outlined"
          selectedValue={measurementRequestType?.value}
          handleChange={handleChange}
          selectOptions={MEASUREMENT_REQUEST_TYPES.filter((type) => type.id !== 5)}
          className={classes.measurementInstructionsSelect}
          disabled={!measurementRequestType?.canEdit || productFamilyId === PRODUCT_FAMILY_ID_EVCORE} // #genai
        />
      </EVGrid>
      <EVGrid className={clsx(classes.measurementInstructionCB, measurementRequestType?.visible === false && 'hide')}>
        <LabelledCheckbox
          checkboxId="measurementRequestType"
          checkBoxName="measurementRequestType"
          handleCheckboxSelectChange={handleMeasurementSubAccountsCheckBoxChange}
          checked={isAdmin && measurementRequestType?.allowSubAccounts}
          checkboxValue={measurementRequestType?.allowSubAccounts}
          disabled={!measurementRequestType?.canEdit || productFamilyId === PRODUCT_FAMILY_ID_EVCORE} // #genai
          checkboxLabel={t('order_preferences__product_selection_measurement_CB')}
          className={classes.deliveryAllowSubsCheckbox}
        />
      </EVGrid>
    </EVGrid>
  );
}

export default ProductSelectionMeasurement;
